// 设置面单预警信息
export const setWarningNotify = params => {
  return window._this.$http.post(`/erp/WavePicking/setWarningNotify`, params);
};



// WEBPACK FOOTER //
// ./src/api/wavePicking.js